import { SourceItem, ChatGPTResponse, SearchState } from "../semantic_search.types";

export const PAGE_SIZE = 10;
export const PREVIEW_TAB_KEY = 'preview';

export type SearchMode = 'fuzzy' | 'wildcard' | 'exact';
export type SearchTarget = 'tickets' | 'emails' | 'all';
export type SortOrder = 'relevance' | 'date';

export interface ISearchSliceState {
    searchResult: SourceItem[];
    checkedSources: ChatGPTResponse | null;
    selectedListItem: SourceItem | null; // Das zuletzt in der Liste ausgewählte Element
    activePreviewItem: SourceItem | null; // Das aktuell in der Vorschau sichtbare Element
    textToHighlight: string[] | null;
    searchState: SearchState;
    currentQuery: string;
    currentPage: number;
    hasMoreResults: boolean;
    isChatGptEnabled: boolean;
    searchMode: SearchMode;
    searchTarget: SearchTarget;
    sortOrder: SortOrder;
    favorites: SourceItem[];
    selectedTabKey: string;
}

export interface ISearchSliceActions {
    setChatGptEnabled: (enabled: boolean) => void;
    startSearch: (query: string) => Promise<void>;
    loadMoreResults: () => Promise<void>;
    setSelectedListItem: (item: SourceItem) => void;
    clearSearch: () => void;
    setSearchMode: (mode: SearchMode) => void;
    setSearchTarget: (target: SearchTarget) => void;
    setSortOrder: (order: SortOrder) => void;
    toggleFavorite: (item: SourceItem) => void;
    setSelectedTabKey: (key: string) => void;
}

export type SemanticSearchStore = ISearchSliceState & ISearchSliceActions;